<template>
  <transition name="fade" appear>
    <div class="screen">
        <div :class="['modal-body', 'alert', props.status]">
          <div class="header">
            <slot name="header">
              
            </slot>
          </div>
          <div class="body">
            <slot name="body">
              
            </slot>
          </div>
          <div class="footer">
            <slot name="footer">
              
            </slot>
          </div>
        </div>
   </div>
   </transition>
</template>

<script setup>
    // Alert modale con overlay. Slot: header, body, footer.
    // status: success (sfondo modal_success.png), error (sfondo card_order.png),
    // warning (bordo superiore arancio), info (bordo superiore azzurro).
    import "@/assets/scss/Help.scss";
    /**
     * @component StatusAlert
     * @description Feedback di stato delle richieste. La visibilità è gestita dal chiamante con v-if
     * (nessuna chiusura propria).
     *
     * @prop {'success'|'error'|'warning'|'info'} [status='success'] - Variante grafica dell'alert
     *
     * @slot header - Titolo/intestazione dell'alert
     * @slot body   - Messaggio principale
     * @slot footer - Azioni (es. pulsante di chiusura)
     */
    const props = defineProps({
    status: {
      type: String,
      default: 'success',
      validator: (v) => ['success', 'error', 'warning', 'info'].includes(v)
    }
  })
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.flex{
  display:flex;
  flex-direction: column;
  justify-content:space-between;
}
.modal-body{
  min-height:500px;
  margin: auto;
  border-radius: 20px;
  padding: 30px;
  width:100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: white;
  position: relative;
  display:flex;
  flex-direction:column;
  justify-content:space-between;
  align-items:center;
}
.footer{
  padding:20px;
  padding-bottom:40px;
}
.body{
  text-align:center;
  padding:20px;
}
.header{
  padding-top:40px;
  padding:20px;
}

.screen{
  position:fixed; 
  left:0px;
  background-color: rgba(108, 108, 108, 0.5); width:100%; height:100%; z-index:100; position:fixed; top:0px;
}
.alert{
  width:30%;
  margin:auto; 
  top:150px;
  z-index:3;
}
.success{
  background-image:  url("@/assets/img/modal_success.png")!important;
}
.error{
  background-image:  url("@/assets/img/card_order.png")!important;
}
.warning{
  background-color: $yellowFive;
  border-top: $alertAccentWidth solid $orange;
}
.info{
  background-color: $greenFive;
  border-top: $alertAccentWidth solid $azure;
}

// Colore del messaggio in base allo status, ereditato dal contenuto dello slot body
.success .body { color: $greenThree; }
.error .body { color: $error; }
.warning .body { color: $yellowSix; }
.info .body { color: $bluSix; }

// Messaggio di stato nello slot body (scope del padre → :deep): testo grande
.body :deep(p) {
  font-family: OpenSansSemiBold;
  font-size: $font24;
  line-height: 1.4;
  color: inherit;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(20px) scale(0.98);
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
  transform: translateY(0) scale(1);
}

</style>